// import cfg from 'cfg';
// import { requestAsync, httpMethods, UPDATE_DEFAULT } from 'dash-front/requery/actions';
import { LOAD_PORTFOLIO } from './constants';
import auth from 'dash-front/auth';
import _ from 'lodash';
import config from 'cfg';

export const addWidget = (portfolio, category, spec) => dispatch => {
    return fetch(
        `${config.dash.api.host}/api/portfolio/${portfolio}/add-widget?access_token=${auth.getAccessToken()}`,
        {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify({
                ...spec,
                category,
            }),
        },
    )
        .then(res => (res.status === 200 ? res.json() : new Error(res.text())))
        .then(() => {
            dispatch(loadPortfolio(portfolio));
        })
        .catch(e => {
            console.log(e);
            alert('e');
        });
};

export const createCategory = (portfolio, name) => dispatch => {
    return fetch(
        `${config.dash.api.host}/api/portfolio/${portfolio}/create-category?access_token=${auth.getAccessToken()}`,
        {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify({
                name,
            }),
        },
    )
        .then(res => (res.status === 200 ? res.json() : new Error(res.text())))
        .then(() => {
            dispatch(loadPortfolio(portfolio));
        })
        .catch(e => {
            console.log(e);
            alert('e');
        });
};

export const updateWidget = (portfolio, id, data) => dispatch => {
    return fetch(
        `${config.dash.api.host}/api/portfolio/${portfolio}/update-widget/${id}?access_token=${auth.getAccessToken()}`,
        {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(data),
        },
    )
        .then(res => (res.status === 200 ? res.json() : new Error(res.text())))
        .then(() => {
            dispatch(loadPortfolio(portfolio));
        })
        .catch(e => {
            console.log(e);
            alert('e');
        });
};

export const loadPortfolio = portfolio => (dispatch, getState) => {
    return fetch(`${config.dash.api.host}/api/portfolio/${portfolio}?access_token=${auth.getAccessToken()}`)
        .then(res => (res.status === 200 ? res.json() : new Error(res.text())))
        .then(portfolio => {
            dispatch({
                type: LOAD_PORTFOLIO,
                payload: portfolio,
            });
        });
};

export const loadTemplate = widgetId => (dispatch, getState) => {
    const state = getState();
    const widgets = _.get(getEntities(state)[STORE_KEYS.WIDGET_SPECS], 'widgets', []);
    const widget = widgets.find(w => w.id === widgetId);

    dispatch({
        // type: WIDGET_SELECTED,
        payload: widget,
    });
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/portfolio/actions.js
 **/